.sectionTitle {
  margin-top: 8px;
  margin-bottom: 8px;
}

.sectionTitleLarge {
  margin-top: 16px;
  margin-bottom: 8px;
}

.uploadArea {
  min-height: 64px;
}
